import { render } from "./Slab.vue?vue&type=template&id=0dc4cf94&scoped=true&ts=true"
import script from "./Slab.vue?vue&type=script&lang=ts"
export * from "./Slab.vue?vue&type=script&lang=ts"

import "./Slab.vue?vue&type=style&index=0&id=0dc4cf94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc4cf94"]])

export default __exports__